import { render, staticRenderFns } from "./PlanosCobranca.vue?vue&type=template&id=efcb77aa"
import script from "./PlanosCobranca.vue?vue&type=script&lang=js"
export * from "./PlanosCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports